import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaStar as FaStarSolid, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const CastingReview = ({ 
    hoverRating, setHoverRating, ratingStar, setRatingStar, 
    reviewText, setReviewText, decision, setDecision, 
    handleSaveReview, saveReviewLoading, bookingType,
    fieldErrors = {}, setFieldErrors, disabled = false 
}) => {
    const currentRating = hoverRating || ratingStar || 0;

    return (
        <div className="card-dark p-3 rounded-3" style={{ background: '#121212', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
            <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-secondary border-opacity-25">
                <h6 className="fw-bold m-0 text-white d-flex align-items-center gap-2 fs-6">
                    <FaCheckCircle className="text-danger" /> Casting Review & Evaluation
                </h6>
                {ratingStar > 0 && (
                    <span className="badge bg-warning text-dark fw-bold px-2 py-1" style={{ fontSize: '11px' }}>
                        ★ {ratingStar} / 5
                    </span>
                )}
            </div>
            
            {/* Star Rating Section */}
            <div className="mb-3">
                <label className="text-muted small fw-semibold mb-1 d-block" style={{ fontSize: '12px' }}>
                    Candidate Rating *:
                </label>
                <div className="d-flex align-items-center gap-1 p-2 rounded" style={{ background: '#1a1a1a', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                    {[...Array(5)].map((_, index) => {
                        const isFilled = index < currentRating;
                        return (
                            <FaStarSolid 
                                key={index} 
                                size={22} 
                                color={isFilled ? "#f59e0b" : "#3d4556"} 
                                onClick={() => {
                                    if (disabled) return;
                                    setRatingStar(index + 1);
                                    if (setFieldErrors) setFieldErrors(prev => ({ ...prev, ratingStar: '' }));
                                }} 
                                onMouseEnter={() => !disabled && setHoverRating(index + 1)} 
                                onMouseLeave={() => !disabled && setHoverRating(0)} 
                                style={{ 
                                    cursor: disabled ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.15s ease',
                                    filter: isFilled ? 'drop-shadow(0 0 5px rgba(245, 158, 11, 0.6))' : 'none'
                                }} 
                            />
                        );
                    })}
                </div>
                {fieldErrors.ratingStar && (
                    <small className="text-danger d-flex align-items-center gap-1 mt-1 fw-semibold" style={{ fontSize: '0.75rem' }}>
                        <FaExclamationCircle size={11} /> {fieldErrors.ratingStar}
                    </small>
                )}
            </div>

            {/* Review Comment Textarea */}
            <div className="mb-3">
                <label className="text-muted small fw-semibold mb-1 d-block" style={{ fontSize: '12px' }}>
                    Evaluation Feedback & Comments *:
                </label>
                <textarea 
                    className="form-control text-white" 
                    rows={4}
                    style={{ 
                        resize: 'none',
                        background: '#1a1a1a',
                        border: fieldErrors.reviewText ? '1px solid #ef4444' : '1px solid rgba(255, 255, 255, 0.12)',
                        borderRadius: '8px',
                        fontSize: '0.85rem',
                        lineHeight: '1.5'
                    }} 
                    placeholder="Write your evaluation, feedback, or casting notes..." 
                    value={reviewText} 
                    disabled={saveReviewLoading || disabled}
                    onChange={(e) => {
                        setReviewText(e.target.value);
                        if (setFieldErrors) setFieldErrors(prev => ({ ...prev, reviewText: '' }));
                    }} 
                />
                {fieldErrors.reviewText && (
                    <small className="text-danger d-flex align-items-center gap-1 mt-1 fw-semibold" style={{ fontSize: '0.75rem' }}>
                        <FaExclamationCircle size={11} /> {fieldErrors.reviewText}
                    </small>
                )}
            </div>

            {/* Status Dropdown */}
            <div className="mb-4"> 
                <label className="text-muted small fw-semibold mb-1 d-block" style={{ fontSize: '12px' }}>
                    Final Casting Decision *:
                </label>
                <select 
                    className="form-select text-white" 
                    style={{
                        background: '#1a1a1a',
                        border: fieldErrors.decision ? '1px solid #ef4444' : '1px solid rgba(255, 255, 255, 0.12)',
                        borderRadius: '8px',
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box'
                    }}
                    value={decision} 
                    disabled={saveReviewLoading || disabled}
                    onChange={(e) => {
                        setDecision(e.target.value);
                        if (setFieldErrors) setFieldErrors(prev => ({ ...prev, decision: '' }));
                    }}
                >
                    <option value="" style={{ background: '#1a1a1a', color: '#9ca3af' }}>-- Select Status --</option>
                    <option value="SELECTED" style={{ background: '#1a1a1a', color: '#10b981', fontWeight: 'bold' }}>Selected</option>
                    <option value="REJECTED" style={{ background: '#1a1a1a', color: '#ef4444', fontWeight: 'bold' }}>Rejected</option>
                    {String(bookingType || "").toUpperCase() === "VIDEO_UPLOAD" && (
                        <option value="RESUBMIT" style={{ background: '#1a1a1a', color: '#f59e0b', fontWeight: 'bold' }}>Resubmit</option>
                    )}
                </select>
                {fieldErrors.decision && (
                    <small className="text-danger d-flex align-items-center gap-1 mt-1 fw-semibold" style={{ fontSize: '0.75rem' }}>
                        <FaExclamationCircle size={11} /> {fieldErrors.decision}
                    </small>
                )}
            </div>

            {!disabled && (
                <Button 
                    className="w-100 fw-bold d-flex align-items-center justify-content-center gap-2 py-2 rounded-2 border-0 shadow-sm"
                    style={{
                        background: 'linear-gradient(135deg, #E10600, #b90500)',
                        fontSize: '0.9rem',
                        boxShadow: '0 4px 15px rgba(225, 6, 0, 0.4)'
                    }} 
                    onClick={handleSaveReview} 
                    disabled={saveReviewLoading}
                >
                    {saveReviewLoading ? (
                        <>
                            <Spinner size="sm" animation="border" />
                            <span>Saving Review...</span>
                        </>
                    ) : (
                        <>
                            <FaCheckCircle /> Save Review & Status
                        </>
                    )}
                </Button>
            )}
        </div>
    );
};

export default CastingReview;